export function getTranslation<T>(cs: T, en: T): T {
  // bSecure doesn't need CZ translations
  return en
}
